import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  headerDialogTitle: {
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },
  mainDialog: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  loadingContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loading: {
    color: neutral['100'],
  },

  emptyState: {
    height: '100%',
    padding: '2rem',
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
  },
  emptyStateIcon: {
    fontSize: '4rem',
    color: neutral[50],
  },
  emptyStateTitle: {
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    color: neutral[100],
  },
  emptyStateBody: {
    maxWidth: '18rem',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[70],
  },

  complaintsSection: {
    display: 'flex',
    gap: '1rem',
    flexDirection: 'column',
    borderTop: `1px solid ${neutral[30]}`,
  },
  labelOfFilterByStore: {
    left: '0.375rem',
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    color: neutral[60],
  },
  selectOfFilterByStore: {
    padding: '1.375rem 2rem 0.5rem 1rem',
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    color: neutral[100],
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[20]}`,
    '&:focus': {
      backgroundColor: neutral.white,
    },
    '&:hover': {
      backgroundColor: neutral[10],
      border: `1px solid ${neutral[40]}`,
    },
  },
});
